import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDownIcon } from 'lucide-react';
import { StageBadge } from './StageBadge';
import { useLeads } from '../contexts/LeadsContext';
import { formatAmount, type Lead } from '../data/mockData';
const accentByKey: Record<Lead['accent'], string> = {
  blue: 'bg-brand',
  teal: 'bg-teal',
  purple: 'bg-navy',
  green: 'bg-success'
};
type QueueCardProps = {
  onSelect: (lead: Lead) => void;
};
export function QueueCard({
  onSelect
}: QueueCardProps) {
  const {
    leads
  } = useLeads();
  const queue = leads;
  const [collapsed, setCollapsed] = useState(false);
  return <section className="rounded-xl border border-gray-200 bg-white" aria-labelledby="queue-heading" data-id="element-603" data-mp="3uhfvqt1sjxx4">
      <div role="button" tabIndex={0} aria-expanded={!collapsed} aria-controls="queue-list" onClick={() => setCollapsed(prev => !prev)} onKeyDown={event => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        setCollapsed(prev => !prev);
      }
    }} className="flex cursor-pointer select-none items-center gap-3 border-b border-gray-200 px-5 py-3.5 transition-colors hover:bg-gray-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand/30" data-id="element-604" data-mp="36fue5hcsaf5">
        <h2 id="queue-heading" className="text-[14px] font-semibold text-ink" data-id="element-605" data-mp="r12upueawjp7">
          Needs you now
        </h2>
        <span className="rounded-full bg-gray-100 px-2 py-0.5 text-[11px] font-semibold text-gray-600" data-id="element-606" data-mp="i2h6bim5eagi">
          {queue.length}
        </span>
        <p className="hidden text-[12px] text-gray-500 sm:block" data-id="element-607" data-mp="d3xljljaj4pq">
          new leads · follow-ups due today · new apps
        </p>
        <Link to="/leads" onClick={event => event.stopPropagation()} className="ml-auto text-[12.5px] font-medium text-brand hover:text-brand-dark" data-id="element-608" data-mp="86e4yez4efum">
          Open full queue
        </Link>
        <ChevronDownIcon className={['h-4 w-4 shrink-0 text-gray-400 transition-transform', collapsed ? '-rotate-90' : 'rotate-0'].join(' ')} aria-hidden="true" data-id="element-609" data-mp="sdaajwhha5h" />
      </div>
      <ul id="queue-list" hidden={collapsed} className="divide-y divide-gray-100" data-id="element-610" data-mp="3n1o96g7rlsaz">
        {queue.map(lead => <li key={lead.id} data-id="element-611" data-mp="3rx3kp1iavc48">
            <button type="button" onClick={() => onSelect(lead)} className="flex w-full items-center gap-3 px-5 py-3.5 text-left transition-colors hover:bg-gray-50 focus:outline-none focus-visible:bg-gray-50" data-id="element-612" data-mp="jjny2s6wx6t5">
              <span className={['h-9 w-[3px] shrink-0 rounded-full', accentByKey[lead.accent]].join(' ')} aria-hidden="true" data-id="element-613" data-mp="9kymfh5m0ilc" />
              <span className="min-w-0 flex-1" data-id="element-614" data-mp="2zairdvi9kpy1">
                <span className="block truncate text-[13.5px] text-ink" data-id="element-615" data-mp="2zbbvsptr33d0">
                  <span className="font-semibold" data-id="element-616" data-mp="1hc4etebf3up9">{lead.name}</span>
                  <span className="text-gray-500" data-id="element-617" data-mp="1cdt4l2h7ni6i">
                    {' '}
                    · {lead.state} · {formatAmount(lead.amount)}
                  </span>
                </span>
                <span className="mt-0.5 block truncate text-[12.5px] text-gray-500" data-id="element-618" data-mp="1qb9c6hb8thzu">
                  {lead.detail}
                </span>
              </span>
              <StageBadge stage={lead.stage} data-id="element-619" data-mp="yn7i73sjsq3v" />
            </button>
          </li>)}
      </ul>
    </section>;
}